import React, { Component } from 'react';
import { Form, Input, Label, Button } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class EndocrineUrogenitalSystem extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="EndocrineUrogenitalSystem">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="EndocrineUrogenitalSystem__Form"
        >
          <h1>{translate('fiche.endocrine_urogenital_system.title')}</h1>

          <Label text={translate('fiche.endocrine_urogenital_system.title')} />
          <Input
            name="endocrine_urogenital_system"
            defaultValue={data.endocrine_urogenital_system}
          />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(EndocrineUrogenitalSystem);
